import React from 'react'
import {CButton, CForm, CFormInput} from "@coreui/react";
import CustomPagination from "../../components/CustomPagination";
import ManageRouteTable from "./ManageRouteTable";


const ManageRoute = () => {
  
  return (
    <div>
      <ManageRouteTable/>
    </div>
  );
}

export default ManageRoute;
